import DOMPurify from "dompurify";
import "./RichTextDisplay.css";

interface Props {
  html?: string | null;
  className?: string;
}

/** Renders saved rich-text HTML (from RichTextEditor) safely — sanitized via
 * DOMPurify before being injected, since this content is shown to every user
 * who can view the Interview Q&A page, not just the person who authored it. */
export default function RichTextDisplay({ html, className }: Props) {
  if (!html) return null;
  const clean = DOMPurify.sanitize(html);

  return (
    <div
      className={`rich-text-display ${className ?? ""}`}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
